import service from '@/request/config/axios'

import ApiPrefix from '@/request/config/prefix'

/** dashboard */
const dashboardService = {
  getDashboardData: (params) =>
    service(`${ApiPrefix.COMMUNITY}/community/figure/statics`, {
      method: 'get',
      params,
    }),

  refreshRedisCache: () =>
    service(`${ApiPrefix.COMMUNITY}/community/webhook`, {
      method: 'post',
    }),
}

export default dashboardService
